import { Children, ReactElement } from 'react';
import { AccordionItemButton } from './AccordionItemButton';
import { DefaultAccordionItemButton } from './defaultElements/DefaultAccordionItemButton';
import { IAccordionItemProps } from './AccordionItem';
import AnimateHeight from 'react-animate-height';
import { useAccordionContext } from './context';
import { Box } from '@apia/theme';

export const AccordionItemContent = ({
  children,
  buttonProps,
}: IAccordionItemProps) => {
  let button = null;

  const actualChildren = Children.toArray(children).filter((current) => {
    if (typeof current !== 'string' && typeof current !== 'number') {
      const element = current as ReactElement;

      if (element.type === AccordionItemButton) {
        button = element;
        return false;
      }
    }
    return true;
  });

  if (button === null && buttonProps)
    button = <DefaultAccordionItemButton {...buttonProps} />;

  const handler = useAccordionContext();
  const isExpanded = handler.hooks.useItemStateSelector(
    (current) => current.isExpanded,
  );
  const id = handler.hooks.useItemId();

  const duration = handler.hooks.usePropsSelector(
    (current) => current.animationDuration,
  );

  return (
    <Box className="accordion__item" data-id={id}>
      {button}
      <AnimateHeight
        className="accordion__item__content"
        height={isExpanded ? 'auto' : 0}
        duration={duration}
        id={`accordion__${handler.id}__${id}`}
      >
        {actualChildren}
      </AnimateHeight>
    </Box>
  );
};
